<template>
  <div>
    <b-container class="check_tool__pannel__result">
      <b-row
        ><b-col :style="{ color: eyeCover ? 'green' : 'red' }"
          >Eye Cover: <b>{{ eyeCover }}</b></b-col
        ></b-row
      >
      <b-row
        ><b-col :style="{ color: noseCover ? 'green' : 'red' }"
          >Nose Cover: <b>{{ noseCover }}</b></b-col
        ></b-row
      >
      <b-row
        ><b-col :style="{ color: mouthCover ? 'green' : 'red' }"
          >Mouth Cover: <b>{{ mouthCover }}</b></b-col
        ></b-row
      >

      <b-row>
        <b-col :style="{ color: noseOccl ? 'green' : 'red' }"
          >NoseOccl: <b>{{ noseOccl }}</b></b-col
        >
      </b-row>
      <b-row>
        <b-col :style="{ color: hasHand ? 'green' : 'red' }"
          >hasHand: <b>{{ hasHand }}</b></b-col
        >
      </b-row>
      <b-row>
        <b-col :style="{ color: hasPacifier ? 'green' : 'red' }"
          >hasPacifier: <b>{{ hasPacifier }}</b></b-col
        >
      </b-row>
      <b-row>
        <b-col :style="{ color: eyeOpen ? 'green' : 'red' }"
          >eyeOpen: <b>{{ eyeOpen }}</b></b-col
        >
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: {
    propsOcclResult: null,
  },
  data() {
    return {
      eyeCover: false,
      noseCover: false,
      mouthCover: false,
      noseOccl: false,
      hasHand: false,
      hasPacifier: false,
      eyeOpen: false,
    };
  },
  watch: {
    propsOcclResult() {
      this.resetOcclResult();
      const result = this.propsOcclResult;
      console.log(this.propsOcclResult);

      // parse occlusion label meta

      this.eyeCover = result.cover_state[0] != 0;
      this.noseCover = result.cover_state[1] != 0;
      this.mouthCover = result.cover_state[2] != 0;
      this.noseOccl = result.occl_state[2] != 0;
      this.hasHand = result.has_hand != 0;
      this.hasPacifier = result.has_pacifier != 0;
      this.eyeOpen = result.eye_open != 0;
    },
  },
  methods: {
    resetOcclResult() {
      this.posture = false;
      this.cover = false;
      this.occlusion = false;
      this.hasHand = false;
      this.hasPacifier = false;
    },
  },
};
</script>
